export default {
    imgUrl: process.env.NODE_ENV === 'production' ? 'https://www.aixtrologics.com/img/' : 'http://localhost/aixtrologics/img/',
    previewUrl: process.env.NODE_ENV === 'production' ? 'https://www.aixtrologics.com/preview/' : 'http://localhost/aixtrologics/preview/',
    ajaxUrl: process.env.NODE_ENV === 'production' ? 'https://www.aixtrologics.com/ajax/' : 'http://localhost/aixtrologics/ajax/',
    ephemeridesUrl: process.env.NODE_ENV === 'production' ? 'https://www.aixtrologics.com/ephemerides/' : 'http://localhost/aixtrologics/ephemerides/'
};
